/*下载文件*/
let downloadFile = function (res: { headers: { [x: string]: string; }; data: BlobPart; }) {//从响应头中解析出中文文件名，e. Content-Disposition: attachment; filename*=utf-8''%E6%84%8F%E8%A7%81%E4%BF%A1%E6%81%AF.xls
    let encodedFile = res.headers["content-disposition"].split("''")[1];  //经过编码的文件名
    let file = decodeURI(encodedFile);  //解码
    let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
    let downloadElement = document.createElement('a');
    let href = URL.createObjectURL(blob); //创建下载的链接
    downloadElement.href = href;
    downloadElement.download = file; //下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); //点击下载
    document.body.removeChild(downloadElement); //下载完成移除元素
    URL.revokeObjectURL(href); //释放掉blob对象}
}
export {
    downloadFile
}
